import type {InputGroupProps as InternalProps} from '@chakra-ui/react';
import {InputGroup as InternalInputGroup} from '@chakra-ui/react';
import {forwardRef} from 'react';

import {inputTheme} from './theme/theme';

/**
 * We must provide our own InputGroup and provide the styleConfig prop
 */
export const InputGroup = forwardRef<'div', InternalProps>((props, ref) => {
  return <InternalInputGroup styleConfig={inputTheme} {...props} ref={ref} />;
});
